import { UI } from '@/shared/design-system/tactical-ui';
import React from 'react';
import { Sun } from 'lucide-react';
import { ModalWrapper } from './ModalWrapper';

interface WakeUpConfirmModalProps {
    onClose: () => void;
    onConfirm: () => void;
}

export const WakeUpConfirmModal: React.FC<WakeUpConfirmModalProps> = ({ onClose, onConfirm }) => (
    <ModalWrapper onClose={onClose} borderColor="#f29b11">
        <div style={{ backgroundColor: 'rgba(242, 155, 17, 0.1)', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
            <Sun size={32} color="#f29b11" />
        </div>
        <h2 style={{ ...UI.text.title, fontSize: 18, margin: "0 0 10px" }}>WAKE UP?</h2>
        <p style={{ fontSize: '13px', color: '#888', margin: '0 0 25px' }}>Are you ready to end the recovery log and sync data?</p>
        <div style={{ display: 'flex', gap: '10px' }}>
            <button onClick={onClose} style={{ flex: 1, padding: '14px', borderRadius: '10px', border: '1px solid #333', backgroundColor: 'transparent', color: '#fff', fontWeight: '900', fontSize: '12px', textTransform: 'uppercase' }}>Sleep</button>
            <button onClick={onConfirm} style={{ flex: 1, padding: '14px', borderRadius: '10px', border: 'none', backgroundColor: '#f29b11', color: '#000', fontWeight: '900', fontSize: '12px', textTransform: 'uppercase' }}>Wake Up</button>
        </div>
    </ModalWrapper>
);
